module.exports = __webpack_public_path__ + "media/components/Sponsors/Layouts/SideMenu/projectIcon-65e01855f6b47bfe68e7a408ed16ea0a.svg";